import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import Button from "../../components/button/Button";
import TopButton from "../../components/topButton/TopButton";
import PageHero from "../../components/pageHero/PageHero";
import ProjectsExplorer from "../../containers/projectsExplorer/ProjectsExplorer";
import { greeting, projectsHeader } from "../../portfolio.js";
import "./Projects.css";

class Projects extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="projects-main">
        <Header theme={theme} />
        <PageHero
          kicker="Portfolio"
          title={projectsHeader.title}
          description={projectsHeader.description}
        />
        <div className="page-wrap">
          <ProjectsExplorer />
          <Button
            text="More projects on GitHub"
            className="project-button"
            href={greeting.githubProfile}
            newTab={true}
          />
        </div>
        <Footer theme={theme} />
        <TopButton theme={theme} />
      </div>
    );
  }
}

export default Projects;
